export default {
  "adopt-me": () => import("/home/runner/work/web/web/apps/web/app/layouts/adopt-me.vue"),
  ads: () => import("/home/runner/work/web/web/apps/web/app/layouts/ads.vue"),
  "anime-defenders": () => import("/home/runner/work/web/web/apps/web/app/layouts/anime-defenders.vue"),
  bladeball: () => import("/home/runner/work/web/web/apps/web/app/layouts/bladeball.vue"),
  "da-hood": () => import("/home/runner/work/web/web/apps/web/app/layouts/da-hood.vue"),
  default: () => import("/home/runner/work/web/web/apps/web/app/layouts/default.vue"),
  gpo: () => import("/home/runner/work/web/web/apps/web/app/layouts/gpo.vue"),
  "hood-modded": () => import("/home/runner/work/web/web/apps/web/app/layouts/hood-modded.vue"),
  mm2: () => import("/home/runner/work/web/web/apps/web/app/layouts/mm2.vue"),
  "ps-99": () => import("/home/runner/work/web/web/apps/web/app/layouts/ps-99.vue"),
  psx: () => import("/home/runner/work/web/web/apps/web/app/layouts/psx.vue")
}